export default __webpack_public_path__ + "static/economy2-ab23b018b5b205d10d357b3c06bb694e.png";